var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "change--wrapper",
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 10, md: 24, xl: 10 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "card--box content-card-box",
                  style: "height: " + (_vm.isAdd ? "320px" : "390px"),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header--title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v(_vm._s(_vm.$t("stores::products-info::base_attr")))]
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "basicForm",
                      attrs: {
                        model: _vm.detailForm,
                        rules: _vm.basicRules,
                        "label-position": "left",
                        "label-width": "80px",
                      },
                    },
                    [
                      !_vm.isAdd
                        ? _c("el-form-item", { attrs: { label: "SPU" } }, [
                            _vm._v(_vm._s(_vm.detailForm.id)),
                          ])
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::name"),
                            prop: "title",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "stores::products-info::input_goods_name"
                              ),
                            },
                            model: {
                              value: _vm.detailForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "title", $$v)
                              },
                              expression: "detailForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system::responsible::供应商"),
                            prop: "supplierId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "input-item",
                                  attrs: { popperAppendToBody: false },
                                  on: { change: _vm.handleSelectSupplier },
                                  model: {
                                    value: _vm.detailForm.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "supplierId",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.supplierId",
                                  },
                                },
                                _vm._l(_vm.supplierList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                              _c("i", {
                                staticClass: "el-icon-plus add-btn",
                                on: {
                                  click: function ($event) {
                                    _vm.showAddSupplier = true
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::category"),
                            prop: "categoryId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-cascader", {
                                staticClass: "input-item",
                                attrs: {
                                  appendToBody: false,
                                  options: _vm.categoryOpt,
                                  props: {
                                    label: "name",
                                    value: "id",
                                    children: "childrens",
                                    checkStrictly: true,
                                  },
                                },
                                model: {
                                  value: _vm.detailForm.categoryId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailForm, "categoryId", $$v)
                                  },
                                  expression: "detailForm.categoryId",
                                },
                              }),
                              _c("i", {
                                staticClass: "el-icon-plus add-btn",
                                on: { click: _vm.handlerAddCateGory },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::currency"),
                            prop: "spuCurrency",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { popperAppendToBody: false },
                                  model: {
                                    value: _vm.detailForm.spuCurrency,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "spuCurrency",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.spuCurrency",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "USD", value: "USD" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 14, md: 24, xl: 14 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "card--box",
                  attrs: {
                    title: _vm.$t("stores::products-info::goods_detail"),
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header--title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("stores::products-info::goods_detail"))
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _c("rich-editor", {
                        attrs: {
                          height: _vm.isAdd ? 232 : 302,
                          placeholder: _vm.$t(
                            "stores::products-info::input_goods_detail"
                          ),
                        },
                        model: {
                          value: _vm.detailForm.spuLongDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailForm, "spuLongDesc", $$v)
                          },
                          expression: "detailForm.spuLongDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-card",
            { staticClass: "card--box img-content-wrapper content-card-box" },
            [
              _c(
                "div",
                {
                  staticClass: "header--title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v(_vm._s(_vm.$t("stores::products-info::goods_info")))]
              ),
              _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v(_vm._s(_vm.$t("stores::products-info::商品图片"))),
              ]),
              _c(
                "el-form",
                {
                  ref: "imgForm",
                  attrs: { model: _vm.detailForm, rules: _vm.basicRules },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "",
                        "label-width": "0",
                        prop: "spuImages",
                      },
                    },
                    [
                      _c("pictureCard", {
                        staticStyle: {
                          "border-radius": "4px",
                          border: "1px solid #dcdfe6",
                          padding: "12px 12px 16px",
                        },
                        attrs: { folder: "product" },
                        model: {
                          value: _vm.detailForm.spuImages,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailForm, "spuImages", $$v)
                          },
                          expression: "detailForm.spuImages",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-between" } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.selectedSkuOpt.length
                              ? false
                              : _vm.detailForm.skus.length >= 1,
                          },
                          on: {
                            click: function () {
                              return _vm.addSku()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::products-info::add_sku")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: !_vm.skuSelections.length },
                          on: {
                            click: function ($event) {
                              _vm.multipleDialog = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("stores::products-info::batch_edit")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { "text-align": "end" } },
                    [
                      _c("el-button", { on: { click: _vm.addAttr } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("stores::products-info::dialog_manager_attr")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("z-table", {
                ref: "skuTable",
                staticStyle: { "margin-top": "24px" },
                attrs: {
                  data: _vm.detailForm.skus,
                  "max-height": 300,
                  pagination: false,
                  columns: _vm.skuTableColumns,
                },
                on: { "selection-change": _vm.onSkuSelections },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "imageUrl",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("ZImg", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: { src: row.imageUrl, fit: "contain" },
                          }),
                        ]
                      },
                    },
                    {
                      key: "weight",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            _vm._s(_vm.$dataCheck(row.weight)) +
                              _vm._s(row.weightUnit)
                          ),
                        ]
                      },
                    },
                    {
                      key: "purchasePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.purchasePrice))),
                        ]
                      },
                    },
                    {
                      key: "compareAtPrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.compareAtPrice))),
                        ]
                      },
                    },
                    {
                      key: "salePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.$dataCheck(row.salePrice)))]
                      },
                    },
                    {
                      key: "safeInventory",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.safeInventory))),
                        ]
                      },
                    },
                    {
                      key: "skuInventory",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.skuInventory))),
                        ]
                      },
                    },
                    _vm._l(_vm.selectedSkuOpt, function (val, index) {
                      return {
                        key: val.label,
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", { key: index }, [
                              _vm._v(
                                " " + _vm._s(row.options[index].value) + " "
                              ),
                            ]),
                          ]
                        },
                      }
                    }),
                    {
                      key: "opt",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.onEdit(scope.row, scope.$index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("system::function::edit")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.onCopy(scope.row, scope.$index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("stores::products-info::copy")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#ff0022" },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteSkuData(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("system::function::delete")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "footer-fixed",
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.back } },
            [_vm._v(_vm._s(_vm.$t("stores::products-info::return")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "mlr16",
              attrs: {
                loading: _vm.saveLoading,
                size: "small",
                type: "primary",
              },
              on: { click: _vm.handleSave },
            },
            [_vm._v(" " + _vm._s(_vm.$t("stores::products-info::save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: _vm.$t("stores::products-info::dialog_manager_attr"),
            visible: _vm.showSetAttributes,
            bodyHeight: "350px",
            "custom-class": "manage-dialog-modal",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSetAttributes = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticClass: "col-manage-item",
                  staticStyle: {
                    "border-right": "1px solid rgba(0, 0, 0, 0.1)",
                  },
                  attrs: { span: 13 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "input-search-box" },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "stores::products-info::input_attr"
                            ),
                          },
                          model: {
                            value: _vm.attrSearchVal,
                            callback: function ($$v) {
                              _vm.attrSearchVal = $$v
                            },
                            expression: "attrSearchVal",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-search",
                            attrs: { slot: "prefix" },
                            on: { click: _vm.getAttrList },
                            slot: "prefix",
                          }),
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::product-manager::attr-add",
                              expression: "'stores::product-manager::attr-add'",
                            },
                          ],
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: _vm.$t("system::common::text::add"),
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-plus add-btn",
                            on: { click: _vm.addProp },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "ul",
                    { staticClass: "prodinfo--edit__attrList" },
                    _vm._l(_vm.attrList, function (item) {
                      return _c(
                        "li",
                        { key: item.id },
                        [
                          _c("span", [_vm._v(_vm._s(item.name))]),
                          _c("el-checkbox", {
                            attrs: {
                              value: _vm.selectedAttrList
                                .map(function (i) {
                                  return i.name
                                })
                                .includes(item.name),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectAttr(item)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "ul",
                  { staticClass: "col-manage-item prodinfo--edit__attrList" },
                  _vm._l(_vm.selectedAttrList, function (item) {
                    return _c("li", { key: item.id }, [
                      _c("span", [_vm._v(_vm._s(item.name))]),
                      _c("i", {
                        staticClass: "el-icon-circle-close",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.closeAttr(item)
                          },
                        },
                      }),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showSetAttributes = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.changeAttributes },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("skuModal", {
        ref: "skuModal",
        attrs: {
          data: _vm.detailForm.skus,
          drawRow: _vm.backRow,
          selectedSkuOpt: _vm.selectedSkuOpt,
          images: _vm.images,
        },
        on: { save: _vm.onSave, onAddAttr: _vm.addAttr },
        model: {
          value: _vm.visable,
          callback: function ($$v) {
            _vm.visable = $$v
          },
          expression: "visable",
        },
      }),
      _c("skuMultiple", {
        on: { edit: _vm.editSkuBtn },
        model: {
          value: _vm.multipleDialog,
          callback: function ($$v) {
            _vm.multipleDialog = $$v
          },
          expression: "multipleDialog",
        },
      }),
      _c("cateModal", {
        attrs: { cateData: _vm.cateInfoData, visible: _vm.showAddCate },
        on: {
          "update:visible": function ($event) {
            _vm.showAddCate = $event
          },
          save: _vm.handleCateSave,
        },
      }),
      _c("edit-dialog", {
        ref: "edit",
        attrs: { isNew: true },
        on: { getListData: _vm.initData },
        model: {
          value: _vm.showAddSupplier,
          callback: function ($$v) {
            _vm.showAddSupplier = $$v
          },
          expression: "showAddSupplier",
        },
      }),
      _c("EditAttrDialog", {
        ref: "editAttr",
        attrs: { isEdit: _vm.isAttrEdit },
        on: { updateData: _vm.handleAddAttrProp },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }